import React, { useContext, useState, useEffect } from "react";
import { DomainDataContext } from "../../store/domaindata-context";
import { useNavigate } from "react-router-dom";
import ErrorPage from "../../pages/ErrorPage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import "./Invite.css";

const Profiles = (props) => {
  console.warn(window.origininfo);

  const profiles = useContext(DomainDataContext);
  const navigate = useNavigate();
  const [profile, setprofile] = useState(false);

  useEffect(() => {
    console.error(profiles);
    if (profiles !== null) {
      if (profiles.data && !profiles.hasError) {
        console.error(profiles.data.TEAMS);
        setprofile(profiles.data.TEAMS[0].TEAMID);
        if (profiles.data.TEAMS.length == 1) {
          navigate("/invite/" + profiles.data.TEAMS[0].TEAMID);
        }
      }
    }
  }, [profiles]);

  const dropdownChangeHandler = (event) => {
    profiles.data.TEAMS.map((team) => {
      if (team.TEAMID == event.target.value) {
        setprofile(event.target.value);
      }
    });
    console.error(profile);
  };

  return (
    <div>
      {!profiles.isLoading && !profiles.hasError && (
        <div className="profile-shell">
          <div className="profile-shell-header">Select Collaboration profile</div>
          <div className="profile-shell-body">
            <select
              className="profile-select"
              aria-label="Select Collaboration profile"
              onChange={dropdownChangeHandler}
              onBlur={dropdownChangeHandler}
              value={profile.TEAMID}
            >
              {profiles.data.TEAMS.map((team) => {
                const { TITLE, TEAMID } = team;
                return (
                  <option key={TEAMID} value={TEAMID}>
                    {TITLE}
                  </option>
                );
              })}
            </select>
            <div className="profile-actions">
              <button
                type="button"
                className="invite-primary-btn"
                onClick={() => {
                  navigate("/invite/" + profile);
                }}
              >
                Next <FontAwesomeIcon icon={faAngleRight} />
              </button>
            </div>
          </div>
        </div>
      )}
      {!profiles.isLoading && profiles.hasError && (
        <ErrorPage error={profiles} />
      )}
    </div>
  );
};

export default Profiles;
